import { Box } from '@mui/material'
import React from 'react'

function GalleryImage({ image }) {
    return (
        <>
            <Box
                component="img"
                sx={{
                    height: "auto",
                    width: "100%",
                    // maxWidth:"500px",
                    borderRadius:"8px"
                   
                    
                }}
                alt="Gallery Image"
                src={image}
            />

        </>
    )
}

export default GalleryImage